<button type="button" class="button-icon" matDialogClose cdkFocusInitial [attr.aria-label]="'dtmUi.closeButtonAltText' | transloco">
    <dtm-ui-icon name="close"></dtm-ui-icon>
</button>
<div class="content">
    <span class="date" *ngIf="data?.newsDate as date">{{ date | localizeDate }}</span>
    <h3 *ngIf="data?.newsTitle as title">{{ title }}</h3>
    <ng-container [ngTemplateOutlet]="data?.template ?? null"></ng-container>
</div>

<mat-dialog-actions align="end">
    <button type="button" class="button-primary" mat-dialog-close>
        {{ "dtmMainPageLib.subpage.kpo.news.closeButtonLabel" | transloco }}
    </button>
</mat-dialog-actions>
